// extracted by mini-css-extract-plugin
module.exports = {"inputArea_div":"style_inputArea_div__XapLq"};